import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import Organization from '@/repositories/data/Organization';

export default class DashboardOrganizationRepository extends BaseCrudRepository<Organization, Organization, number> {
    public constructor(client: HttpClient) {
        super(client, 'api/organizations/dashboard', 'ORGANIZATIONS');
    }
}
